import React from "react";
import { Link } from "react-router-dom";
import { Facebook, Instagram, Phone, Twitter } from "lucide-react";
import { BeloLogo } from "@/components/BeloLogo";
import { useBrandConfig } from "@/hooks/useBrandConfig";

export const Footer = () => {
  const { bdc_phone_display, bdc_phone_href } = useBrandConfig();
  return (
    <footer className="mt-24 bg-slate-950 text-slate-300" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div className="md:col-span-2">
          <BeloLogo height={48} color="#ffffff" />
          <p className="mt-4 text-sm text-slate-400 max-w-md leading-relaxed">
            Belomotors.com — a curated Massachusetts used-car marketplace. One search across
            our trusted partner dealerships. No pressure, just great cars.
          </p>
          <a
            href={bdc_phone_href}
            className="mt-5 inline-flex items-center gap-2 text-white hover:text-gold transition-colors font-semibold"
            data-testid="footer-bdc-phone-link"
          >
            <Phone size={16} className="text-gold" />
            <span>
              <span className="block text-[10px] uppercase tracking-widest text-slate-400 font-medium">
                BDC concierge
              </span>
              <span className="text-base">{bdc_phone_display}</span>
            </span>
          </a>
          <div className="flex items-center gap-3 mt-6">
            <a href="#" className="text-slate-500 hover:text-white transition-colors" aria-label="Twitter">
              <Twitter size={18} />
            </a>
            <a href="#" className="text-slate-500 hover:text-white transition-colors" aria-label="Instagram">
              <Instagram size={18} />
            </a>
            <a href="#" className="text-slate-500 hover:text-white transition-colors" aria-label="Facebook">
              <Facebook size={18} />
            </a>
          </div>
        </div>

        <div>
          <h4 className="text-xs uppercase tracking-widest text-slate-500 font-semibold">Shop</h4>
          <ul className="mt-4 space-y-2 text-sm">
            <li><Link to="/inventory" className="hover:text-white">Inventory</Link></li>
            <li><Link to="/dealers" className="hover:text-white">Partner Dealerships</Link></li>
            <li><Link to="/inventory?body_style=suv" className="hover:text-white">SUVs</Link></li>
            <li><Link to="/inventory?body_style=truck" className="hover:text-white">Trucks</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="text-xs uppercase tracking-widest text-slate-500 font-semibold">Company</h4>
          <ul className="mt-4 space-y-2 text-sm">
            <li><Link to="/signup" className="hover:text-white">Sign up</Link></li>
            <li><Link to="/login" className="hover:text-white">Log in</Link></li>
            <li>
              <a
                href={bdc_phone_href}
                className="hover:text-white inline-flex items-center gap-1"
                data-testid="footer-contact-bdc-link"
              >
                <Phone size={13} /> Contact BDC · {bdc_phone_display}
              </a>
            </li>
            <li><a href="#" className="hover:text-white">Privacy</a></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-slate-800 py-6 text-center text-xs text-slate-500">
        © {new Date().getFullYear()} Belomotors.com — Massachusetts&apos;s curated used-car marketplace.
      </div>
    </footer>
  );
};
